import { type ReactNode } from 'react';

interface UserTableSectionProps {
    title: string;
    count: number;
    description: string;
    action?: ReactNode;
    children: React.ReactNode;
}

export default function UserTableSection({
    title,
    count,
    description,
    action,
    children,
}: UserTableSectionProps) {
    return (
        <section>
            <div className="mb-3 flex items-center justify-between gap-3">
                <div>
                    <div className="flex items-center gap-2">
                        <h3 className="text-xl font-semibold text-foreground">
                            {title}
                        </h3>
                        <span className="rounded-full bg-zinc-300 px-2 py-0.5 text-xs font-medium tabular-nums text-zinc-800">
                            {count}
                        </span>
                    </div>
                    <p className="mt-1 text-sm text-muted-foreground">
                        {description}
                    </p>
                </div>
                {action}
            </div>
            {children}
        </section>
    );
}